module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-2-Video.bfe9f80d.jpg";